import { Controller } from "@hotwired/stimulus";

interface ParamsValue {
  [key: string]: string | number;
}

export default class UrlUpdaterController extends Controller {
  static values = {
    params: Object,
  };

  declare readonly paramsValue: ParamsValue;

  updateUrl(event: Event): void {
    const currentParams = new URLSearchParams(window.location.search);

    Object.entries(this.paramsValue).forEach(([key, value]) => {
      currentParams.set(key, value.toString());
    });

    window.history.pushState({}, "", `${window.location.pathname}?${currentParams.toString()}`);
  }
}
